import { FC, ReactElement, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import {isLoggedIn} from "@/helpers";
import {PATH} from './Paths';

interface Props {
  element: ReactElement;
}

const ProtectedRoute: FC<Props> = ({ element: Component }) => {
  const location = useLocation();
  const checkEveryMinute = 5;
  useEffect(() => {
    const interval = setInterval(() => {
      if(!isLoggedIn()){
        window.location.href = PATH.login;
      }
    }, checkEveryMinute * 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if(!isLoggedIn()){
      window.location.href = PATH.login;
    }
  },[location]);

  if (!isLoggedIn()) {
    return <Navigate to={PATH.login} state={{ from: location }} replace />;
  }

  return Component;
};

export default ProtectedRoute;
